import { useEffect, useState } from 'react';
import { Input } from '@/components/ui/input';
import { parseCartQuantity } from '@/lib/cart-quantity.mjs';

export default function CartQuantityInput({ value, onValueChange, onKeyDown, ...props }) {
  const [text, setText] = useState(String(value));
  useEffect(() => { setText(String(value)); }, [value]);
  return <Input {...props} type="text" inputMode="decimal" value={text}
    onFocus={event => event.currentTarget.select()}
    onChange={event => {
      const raw = event.target.value, qty = parseCartQuantity(raw);
      setText(raw);
      event.currentTarget.setCustomValidity(qty == null ? 'QTY harus berupa angka lebih dari 0, misalnya 0,5.' : '');
      if (qty != null) onValueChange(qty);
    }}
    onBlur={event => {
      if (parseCartQuantity(text) == null) setText(String(value));
      event.currentTarget.setCustomValidity('');
    }}
    onKeyDown={event => {
      if (event.nativeEvent.isComposing) return;
      if (event.key === 'Enter') {
        event.preventDefault(); event.stopPropagation();
        if (event.repeat) return;
        const valid = parseCartQuantity(text) != null;
        event.currentTarget.setCustomValidity(valid ? '' : 'QTY harus berupa angka lebih dari 0, misalnya 0,5.');
        if (!event.currentTarget.reportValidity()) return;
      }
      onKeyDown?.(event);
    }} />;
}
